import { Controller } from "@hotwired/stimulus"

// Keep the existing Ads conversion ID after moving the thank-you page off WordPress.
// Its codeless URL rule is locked to dantyba.lophocdan.com in Google Ads.
export default class extends Controller {
  connect() {
    if (window.location.hostname !== "lophocdan.com") return
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.element.dataset.conversionSent === "true") return
    if (typeof window.gtag !== "function") return

    window.gtag("event", "conversion", {
      send_to: "AW-687972822/HHvzCIvFs6IaENbDhsgC",
      value: 1,
      currency: "VND"
    })

    // Retained by Turbo's cached DOM, so restoring this page does not send again.
    this.element.dataset.conversionSent = "true"
  }
}
